export const URL_VALIDATION_MESSAGES = {
	EMPTY: 'Url cannot be empty',
	MIN_LENGTH: (min: number): string => `Please enter at least ${min} characters`,
	SPACES_NOT_ALLOWED: 'Spaces are not allowed',
	INVALID_URL: 'Enter a valid URL, e.g. https://example.com'
};
